import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import QRCode from 'qrcode.react';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import Button from '@material-ui/core/Button';
import useForm from '@afosto/utils-react/validation/useForm';
import { FormattedMessage } from 'react-intl';
import validationSchema from './validations';
import translations from './translations';

const StepConnect = ({ onSubmit, qrCodeUrl }) => {
  const intl = useIntl();
  const [unableToVerify, setUnableToVerify] = useState(false);

  const form = useForm({
    validationSchema,
    onSubmit: async data => {
      setUnableToVerify(false);

      if (onSubmit) {
        try {
          const response = await onSubmit(data);
          const { data: { is_verified: isVerified } = {} } = response;

          if (!isVerified) {
            setUnableToVerify(true);
          }
        } catch (err) {
          setUnableToVerify(true);
        }
      }
    },
  });

  return (
    <>
      {qrCodeUrl && (
        <>
          <Typography variant="body2">
            <FormattedMessage {...translations.formStep.connect.description} />
          </Typography>
          <Grid container justify="center" style={{ marginTop: 32, marginBottom: 32 }}>
            <QRCode id="2fa-qr-code" value={qrCodeUrl} size={200} level="L" includeMargin />
          </Grid>
          <Typography variant="body2">
            <FormattedMessage {...translations.formStep.connect.instruction} />
          </Typography>
        </>
      )}
      <Form form={form} renderActions={false}>
        <TextField
          name="otp"
          label={intl.formatMessage(translations.fields.code.label)}
          autoFocus
        />
        {unableToVerify && (
          <Typography variant="caption" color="error">
            <FormattedMessage {...translations.errors.unableToVerify} />
          </Typography>
        )}
        <Grid container justify="flex-end">
          <Button type="submit" variant="contained" color="primary">
            <FormattedMessage {...translations.formActions.verify} />
          </Button>
        </Grid>
      </Form>
    </>
  );
};

StepConnect.propTypes = {
  onSubmit: PropTypes.func,
  qrCodeUrl: PropTypes.string,
};

StepConnect.defaultProps = {
  onSubmit: undefined,
  qrCodeUrl: null,
};

export default StepConnect;
